export default {
  methods: {
    convertToAddress(data) {
      return {
        region: {
          nameUa: data?.region || data?.city?.region || null,
          nameEn: data?.region_en || data?.city?.region_en || null,
        },
        city: {
          id: data?.city?.id || data?.id || null,
          arxId: data?.arx_id || data?.city?.arx_id || null,
          cdbMtibuCode: data?.cdb_mtibu_code || data?.city?.cdb_mtibu_code || data?.cdbMtibuCode || data?.city?.cdbMtibuCode || null,
          kaotuu: data?.kaotuu || data?.city?.kaotuu || null,
          nameUa: data?.name || data?.city?.name || data?.name_ua || data?.city?.name_ua || data?.nameUa || data?.city?.nameUa || null,
          nameRu: data?.name_ru || data?.city?.name_ru || data?.nameRu || data?.city?.nameRu || null,
          nameEn: data?.name_en || data?.city?.name_en || data?.nameEn || data?.city?.nameEn || data?.city_en || data?.city?.city_en || data?.cityEn || data?.city?.cityEn || null,
          nameFullNameUa: data?.name_full_name_ua || data?.city?.name_full_name_ua || data?.nameFullNameUa || data?.city?.nameFullNameUa || null,
          nameFullNameRu: data?.name_full_name_ru || data?.city?.name_full_name_ru || data?.nameFullNameRu || data?.city?.nameFullNameRu || null,
          typePopulation: data?.type_population || data?.city?.type_population || null,
          zone: data?.zone || data?.city?.zone || null,
        },
        street: {
          nameUa: data?.street || data?.city?.street || null,
          nameEn: data?.street_en || data?.city?.street_en || null,
        },
        buildingNumber: data?.house || data?.city?.house || null,
        apartmentNumber: data?.flat || data?.city?.flat || null,
      };
    },
  },
};
